// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OzLI","label":"styles_label__33tpb"};